// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceAndActionsStyle } from "@west/App/Components/Product/ProductPriceAndActions";
import { css } from "styled-components";

productPriceAndActionsStyle.priceAndQtyContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap: 8px;

        &:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.productFields = {
    css: css`
        display: flex;
        gap: 8px;
        align-items: center;
        height: 33px;
        position: relative;
        &:empty,
        & > div:empty {
            display: none;
        }
    `,
};

productPriceAndActionsStyle.addToCartActions = {
    css: css`
        display: flex;
        flex: 1;
    `,
};

productPriceAndActionsStyle.addToCartButton = {
    css: css`
        flex: 1;
    `,
};

productPriceAndActionsStyle.productImageStyles = {
    wrapper: {
        css: css`
            margin-right: auto;
            margin-left: 2px;
        `,
    },
    compareCheckboxWrapper: {
        css: css`
            display: inline-flex;
        `,
    },
};

productPriceAndActionsStyle.qtyDetailsTooltip = {
    mergeCss: true,
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 16px;
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            margin: 0;
        `,
    },
};

productPriceAndActionsStyle.qtyDetailsTooltipList = {
    mergeCss: true,
    typographyProps: {
        css: css`
            font-size: 12px;
            line-height: 16px;
        `,
    },
    cssOverrides: {
        tooltipWrapper: css`
            position: absolute;
            left: -27px;
        `,
    },
};

productPriceAndActionsStyle.qtyDetailsTooltipIcon = {
    size: 14,
    color: "common.ui8",
};
